import { _window } from "../../app-constants";
import { IPartnerDocs, IRegion, PackageKey } from "./interface";

export default {
  apiUrl: process.env.REACT_APP_PP_BASE_URL,
  productId: String(process.env.REACT_APP_PP_PRODUCT_ID),
  excessFee1: 100,
  isSandBoxMode: parseInt(process.env.REACT_APP_PP_IS_SANDBOX || "0"),
  publishableKey: process.env.REACT_APP_PP_PUBLISHABLE_KEY,
  affiliatedId: process.env.REACT_APP_PP_AFFILIATED_ID || "1",
  defaultAPIError:
    "We are unable to process your order online. Please contact our Customer Services team on +32 2 620 28 30 or at europe@battleface.com.",
};

export const ppVersion = process.env.REACT_APP_PP_VERSION || "1.0.0";

export const portuguesePackageDisplayNames: { [key: string]: string } = {
  "base package": "Base Package",
  "base and optional package": "Base and Optional Package",
};

export const productBasedDestinationCountry: { [Key: string]: string } = {
  "1150": "eu",
  "1151": "world",
  "1152": "worldwide excluding us and canada",
};

export const portugueseUrlAndDocs: { [key: string]: string } = {
  termsAndConditions:
    _window.BFPlugin?.pp?.termsAndConditions || `https://www.battleface.com/en-eu/terms-conditions?ver=${ppVersion}`,
  cookiePolicy: _window.BFPlugin?.pp?.cookiePolicy || `https://www.battleface.com/en-eu/cookie-policy?ver=${ppVersion}`,
  privacyPolicy:
    _window.BFPlugin?.pp?.privacyPolicy || `https://www.battleface.com/en-eu/privacy-policy?ver=${ppVersion}`,
  IPID: _window.BFPlugin?.pp?.IPID || `/docs/portuguese-path/IPID.pdf?ver=${ppVersion}`,
  insuranceDisclosure:
    _window.BFPlugin?.pp?.insuranceDisclosure ||
    `https://www.battleface.com/documents/eir-forsakring-disclosures-travel-medical.pdf?ver=${ppVersion}`,
  travelMedicalDisclosures:
    _window.BFPlugin?.pp?.travelMedicalDisclosures ||
    `docs/portuguese-path/bf_IPID_ENG 260824.pdf?ver=${ppVersion}`,
};

export const documentsByIdAndPackage: IPartnerDocs = {
  1: {
    base_package: _window.BFPlugin?.pp?.defaultBasePackage || `/docs/portuguese-path/base_package.pdf?ver=${ppVersion}`,
    base_and_optional_package:
      _window.BFPlugin?.pp?.defaultBaseAndOptionalPackage ||
      `/docs/portuguese-path/base_and_optional_package.pdf?ver=${ppVersion}`,
  },
  895: {
    base_package:
      _window.BFPlugin?.pp?.basePackage ||
      `/docs/portuguese-path/SI_Erasmus_Catolica_Base_Wording_ENG_070125.pdf?ver=${ppVersion}`,
    base_and_optional_package:
      _window.BFPlugin?.pp?.baseAndOptionalPackage ||
      `/docs/portuguese-path/SI_Erasmus_Catolica_incl_TCAN_Wording_ENG_070125.pdf?ver=${ppVersion}`,
  },
};

export const getDocumentsForPackage = (id: number, packageName: PackageKey): string | null => {
  if (documentsByIdAndPackage[id] && documentsByIdAndPackage[id][packageName]) {
    return documentsByIdAndPackage[id][packageName];
  }
  return null;
};

export const calculateAge = (birthDate: Date | null, from: Date | null = null) => {
  if (!birthDate) {
    return {
      years: 0,
      months: 0,
      days: 0,
    };
  }

  if (!from) {
    from = new Date();
  }

  // Calculate years
  let years;
  if (
    from.getMonth() > birthDate.getMonth() ||
    (from.getMonth() === birthDate.getMonth() && from.getDate() >= birthDate.getDate())
  ) {
    years = from.getFullYear() - birthDate.getFullYear();
  } else {
    years = from.getFullYear() - birthDate.getFullYear() - 1;
  }

  // Calculate months
  let months = 0;
  if (from.getDate() >= birthDate.getDate()) {
    months = from.getMonth() - birthDate.getMonth();
  } else if (from.getDate() < birthDate.getDate()) {
    months = from.getMonth() - birthDate.getMonth() - 1;
  }
  // make month positive
  months = months < 0 ? months + 12 : months;

  // Calculate days
  let days;
  // days of months in a year
  let monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (from.getDate() >= birthDate.getDate()) {
    days = from.getDate() - birthDate.getDate();
  } else {
    days = from.getDate() - birthDate.getDate() + monthDays[birthDate.getMonth()];
  }

  return {
    years,
    months,
    days,
  };
};

export const validateAge = (_mainApplicant: any, _otherApplicant: any, _startDate: any) => {
  const d = calculateAge(_mainApplicant, _startDate);

  if (d.years < 150 && d.years >= 66) {
    // Here check for 150 is to ensure that the year of birth entered is abobe 1900
    return "We've got You covered for trips lasting up to 31 days. If You require cover for longer adventures, please call Us on +44 (20) 4586 0607.";
  }

  return null;
};

export const regions: IRegion[] = [
  {
    label: "Europe",
    value: "1150",
  },
  {
    label: "Worldwide including USA/Canada/Caribbean",
    value: "1151",
  },
  {
    label: "Worldwide excluding USA/Canada/Caribbean",
    value: "1152",
  },
];

export const portugueseCustomDescriptions: any = {
  base_package: {
    "Travel Medical Expenses":
      "Up to €1.000.000 for the costs to treat a medical emergency, including COVID-19, during a trip. €50 deductible. Includes Emergency Dental Expenses: Up to €500 for emergency dental expenses related to accidental injury to sound natural teeth. €50 deductible.",
    "Emergency Evacuation & Repatriation of Remains":
      "Up to €500.000 for the cost of emergency medical transportation to get you to the nearest adequate medical facility, or home, in the event of a medical emergency during your covered trip. Also covers expenses related to repatriation of remains in the event of your death while on the trip.",
    "Baggage and Personal Effects":
      "Up to €1.000 for reimbursement of lost, stolen, or damaged luggage and personal effects. Per-item limit may apply. €50 deductible.",
    "Personal liability":
      " Up to €500.000 for legal costs, settlements, or judgments against you, if you are held legally responsible for causing bodily injury to another person or damage to someone else's property during your trip. €100 deductible.",
  },
  base_and_optional_package: {
    "Trip Cancellation":
      "Coverage up to 100% of your pre-paid, non-refundable trip cost if you need to cancel your trip for a covered reason. Maximum trip cost of €2.000 per insured.",
    "Trip Interruption":
      " Coverage up to 100% of your pre-paid and non-refundable trip cost if a portion of a trip is missed, or if you must return home early due to unforeseen circumstances, including illness, injury, or death. Maximum trip cost of €2.000 per insured.",
    "Trip curtailment":
      "Up to €750 for necessary travel expenses if you must return home early due to unforeseen circumstances, including illness, injury, or death.",
  },
};
